<template>
  <div
    class="card-body"
    v-if="report && reportEntry"
  >
    <div
      class="row"
    >
      <div class="col-11">
        <p>login: <strong>{{ reportEntry.agentCode }}</strong></p>
        <p>run: {{ reportEntry.id }}</p>
        <p>property service limit: {{ reportEntry.runConfig.numberOfProperties }} <span v-if="validPromotion( reportEntry )">(upgraded to {{ reportEntry.runConfig.promotionalProperties }})</span></p>
        <p>swap feed: {{ reportEntry.runConfig.swapFeed }}</p>
        <p>schema  no: {{ reportEntry.runConfig.importSchema }}</p>
        <p>order: {{ order( reportEntry ) }}</p>
        <p>feed: {{ reportEntry.runConfig.overrides && reportEntry.runConfig.overrides.importUrl ? reportEntry.runConfig.overrides.importUrl : reportEntry.runConfig.importUrl }}</p>
        <p v-if="reportEntry.runConfig.cleanDescriptions">
          clean descriptions: {{ reportEntry.runConfig.cleanDescriptions }}
        </p>
        <p>
          <a
            :href="linkToProperties( reportEntry )"
            target="_blank"
          >
            agent online properties
          </a>
        </p>
        <p>start: {{ toLocaleString( reportEntry.start ) }}</p>
        <p
          v-if="!reportEntry.end"
          class="alert alert-warning"
        >
          Import in progress or hasn't completed yet
        </p>
        <p
          v-else
        >
          end: {{ toLocaleString( reportEntry.end ) }}
        </p>
        <p
          v-if="report && report.agentLogin"
        >
          <button
            class="btn btn-outline-secondary"
            @click="viewRawXml ( reportEntry.agentCode, reportEntry.id )"
          >
            view xml file last processed
          </button>
          <button
            class="btn btn-outline-secondary"
            @click="downloadRawXml ( reportEntry.agentCode, reportEntry.id )"
          >
            download xml file last processed
          </button>
          <button
            v-if="canAddRule"
            class="btn btn-outline-secondary"
            @click.prevent="cleanCacheForRun( reportEntry.id )"
          >
            clear description cleanup for this run
          </button>
        </p>
        <p v-if="showReprocessAction && canRunImport">
          <button
            v-if="!processing"
            class="btn btn-outline-primary"
            @click="startImport()"
          >
            reprocess
          </button>
          <span
            v-if="processing"
          >
            Import in progress... page will refresh automatically when done
          </span>
        </p>
        <p
          v-if="reportEntry.processingError"
          :class="reportEntry.processingError ? 'alert alert-danger' : ''"
        >
          processing error: {{ reportEntry.processingError }}
        </p>
        <p
          v-if="reportEntry.dbWriteError"
          :class="reportEntry.dbWriteError ? 'alert alert-danger' : ''"
        >
          db write error: {{ reportEntry.dbWriteError }}
        </p>
        <p
          v-if="reportEntry.changeLog"
        >
          change log:
          <pre
            class="flex-wrap"
            style="text-align: left;"
            v-html="JSON.stringify(reportEntry.changeLog, null, 4)"
          />
        </p>
        <p v-if="imageReport">
          Current image report for login:
          <a
            @click.prevent="detailedImageReportMode = true"
            href=""
          >
            see detailed report
          </a>
        </p>
        <ul v-if="imageReport">
          <li>
            total images: {{ imageReport.reduce((total, p) => total + p.total, 0) }}
            <button
              class="btn btn-sm btn-outline-secondary"
              v-if="canReprocessImages && !reprocessImagesStarted"
              @click.prevent="reprocessImages( true )"
              href=""
            >
              reprocess images
            </button>
            <span
              v-if="reprocessImagesStarted"
            >
              Reprocessing images in progress... Refresh report in a few minutes
            </span>
          </li>
          <li>
            processed images: {{ imageReport.reduce((total, p) => total + p.processed, 0) }}
          </li>
          <li>
            invalid images: {{ imageReport.reduce((total, p) => total + p.invalid, 0) }}
            <a
              @click.prevent="invalidImagesReportMode = true;loadInvalidImages()"
              href=""
            >
              see
            </a>
            <button
              class="btn btn-sm btn-outline-secondary"
              v-if="canReprocessFailedImages && !reprocessFailedImagesStarted"
              @click.prevent="reprocessFailedImages( false )"
              href=""
            >
              reprocess failed images
            </button>
            <span
              v-if="reprocessFailedImagesStarted"
            >
              Reprocessing failed images in progress... Refresh report in a few minutes
            </span>
          </li>
        </ul>
        <p
          v-if="reportEntry.processingStats"
        >
          processing stats:
        </p>
        <ul v-if="recalculateWithImageReport && imageReport">
          <li>
            valid, on-line: {{ reportEntry.processingStats.online - publicWithAllImagesInvalid - publicWithNoValidImagesButSomeInProgress }}
          </li>
          <li>
            valid, off-line because all images invalid: {{ publicWithAllImagesInvalid }}
          </li>
          <li>
            valid, off-line because images in progress: {{ publicWithNoValidImagesButSomeInProgress }}
          </li>
          <li>
            valid over service limit: {{ reportEntry.processingStats.offline }}
          </li>
          <li>
            invalid: {{ reportEntry.processingStats.invalid }}
          </li>
          <li>
            excluded: {{ reportEntry.processingStats.unmatched + ( reportEntry.processingStats.ignored ? reportEntry.processingStats.ignored : 0 ) }}
          </li>
        </ul>
        <div
          v-if="!recalculateWithImageReport"
          class="alert alert-warning"
        >
          This import report does not amend valid properties with invalid images
        </div>
        <ul v-if="!recalculateWithImageReport">
          <li>
            valid: {{ reportEntry.processingStats.online }}
          </li>
          <li>
            valid over service limit: {{ reportEntry.processingStats.offline }}
          </li>
          <li>
            invalid: {{ reportEntry.processingStats.invalid }}
          </li>
          <li>
            excluded: {{ reportEntry.processingStats.unmatched + ( reportEntry.processingStats.ignored ? reportEntry.processingStats.ignored : 0 ) }}
          </li>
        </ul>
        <div
          v-if="report && report.agentLogin"
        >
          <p
            v-if="Object.keys(report.validationErrorStats).length > 0"
          >
            property validation errors:
          </p>
          <ul v-if="Object.keys(report.validationErrorStats).length > 0">
            <li
              v-for="(value, key) in report.validationErrorStats"
              :key="key"
            >
              {{ key }}: {{ value }}
              <button
                class="btn btn-link"
                v-if="key == 'Property type unresolved' && !propertyResolutionJob && canAddRule"
                @click="resolveAllPropertyTypes()"
              >
                resolve for all using ai
              </button>
              <button
                class="btn btn-link"
                v-if="key == 'Location information unresolved' && !propertyLocationResolutionJob && canAddRule"
                @click="resolveAllPropertyLocations()"
              >
                resolve for all using ai
              </button>
              <p v-if="key == 'Property type unresolved' && propertyResolutionJob">
                Status (will update when ready, processing 30 properties per minut): {{ JSON.stringify( propertyResolutionJob, null, 2 ) }}
              </p>
              <p v-if="key == 'Location information unresolved' && propertyLocationResolutionJob">
                Status (will update when ready, processing 150 properties per minut): {{ JSON.stringify( propertyLocationResolutionJob, null, 2 ) }}
              </p>
            </li>
          </ul>
          <p>Show only: </p>
          <div
            class="btn-group"
            role="group"
            aria-label="Basic example"
          >
            <button
              type="button"
              :class="`btn btn-${statusFilters.length == 0 ? 'primary':'secondary' }`"
              @click="setFilter( )"
            >
              All
            </button>
            <button
              type="button"
              :class="`btn btn-${statusFilters.includes('online') ? 'primary':'secondary' }`"
              @click="setFilter( ['online'] )"
            >
              Valid
            </button>
            <button
              type="button"
              :class="`btn btn-${statusFilters.includes('offline') ? 'primary':'secondary' }`"
              @click="setFilter( ['offline'] )"
            >
              Valid over service limit
            </button>
            <button
              type="button"
              :class="`btn btn-${statusFilters.includes('invalid') ? 'primary':'secondary' }`"
              @click="setFilter( ['invalid'] )"
            >
              Invalid
            </button>
            <button
              type="button"
              :class="`btn btn-${statusFilters.includes('unmatched') && statusFilters.includes('ignored') ? 'primary':'secondary' }`"
              @click="setFilter( ['unmatched', 'ignored'] )"
            >
              Excluded
            </button>
          </div>
          <br>
          <br>
          <p>Filter errors: </p>
          <div
            class="btn-group"
            role="group"
            aria-label="Basic example"
          >
            <button
              type="button"
              :class="`btn btn-${errorFilters.length == 0 ? 'primary':'secondary' }`"
              @click="setErrorFilter('')"
            >
              All
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('AgentRef is empty') ? 'primary':'secondary' }`"
              @click="setErrorFilter('AgentRef is empty')"
            >
              AgentRef is empty
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('Duplicated unique_id') ? 'primary':'secondary' }`"
              @click="setErrorFilter('Duplicated unique_id')"
            >
              Duplicated unique_id
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('UniqueID is empty') ? 'primary':'secondary' }`"
              @click="setErrorFilter('UniqueID is empty')"
            >
              UniqueID is empty
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('Location information unresolved') ? 'primary':'secondary' }`"
              @click="setErrorFilter('Location information unresolved')"
            >
              Location information unresolved
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('Property type unresolved') ? 'primary':'secondary' }`"
              @click="setErrorFilter('Property type unresolved')"
            >
              Property type unresolved
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('Price is empty') ? 'primary':'secondary' }`"
              @click="setErrorFilter('Price is empty')"
            >
              Price is empty
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('Price is too low') ? 'primary':'secondary' }`"
              @click="setErrorFilter('Price is too low')"
            >
              Price is too low
            </button>
            <button
              type="button"
              :class="`btn btn-${errorFilters.includes('Price is too high') ? 'primary':'secondary' }`"
              @click="setErrorFilter('Price is too high')"
            >
              Price is too high
            </button>
          </div>
          <p />
          <p>
            Filter by agent ref:
            <input
              type="text"
              v-model="agentRefFilter"
              @change="updateReport"
            >
          </p>
          <p>
            Filter by our id:
            <input
              type="number"
              v-model="ourIdFilter"
              @change="updateReport"
            >
          </p>
          <p>
            Filter by issue:
            <input
              type="text"
              v-model="issueFilter"
              @change="updateReport"
            >
          </p>
          <p />
        </div>
      </div>
      <div
        class="col-1"
        v-if="showCloseButton"
      >
        <button
          type="button"
          class="btn btn-secondary"
          @click="$emit( 'close' )"
        >
          Close
        </button>
      </div>
    </div>
    <div
      class="row"
      v-if="report && report.agentLogin"
    >
      <div class="col-12">
        <table
          class="table table-striped"
        >
          <thead>
            <th>Status</th>
            <th>Offer</th>
            <th>First Photo</th>
            <th>Agent Ref / Unique Id</th>
            <th>Price</th>
            <th>Type</th>
            <th>Description</th>
            <th>Location</th>
            <th>Lat/Lng</th>
            <th>Validation Errors</th>
            <th>Read issues</th>
            <th
              style="width: 200px;"
            />
          </thead>
          <tbody>
            <tr
              v-for="property in report.properties"
              :key="property.id"
            >
              <td>
                {{ getStatus( property.status ) }}
              </td>
              <td>{{ property.property.offer }}</td>
              <td>
                <img
                  v-for="photo in takeTop( property.property.photos )"
                  :src="photo.url"
                  :key="photo.url"
                  :alt="photo.number"
                  height="80"
                  style="padding: 4px;"
                >
                <button
                  type="button"
                  class="btn btn-link"
                  @click="allPhotosMode = true; selectedProperty = property;"
                >
                  view all
                </button>
              </td>
              <td>
                {{ property.property.agentRef }}
                <br>
                {{ property.property.uniqueId }}
              </td>
              <td>{{ property.property.price }} {{ property.property.currency }}</td>
              <td>{{ getPropertyTypeTextById( property.property.type ) }}</td>
              <td
                v-html="getDescriptionSample(property.property)"
              />
              <td
                v-html="showLocation( property )"
              />
              <td>{{ formatLatLngInfo(property) }}</td>
              <td>
                <ul>
                  <li
                    v-for="error in property.validationErrors"
                    :key="error"
                  >
                    {{ error }}
                  </li>
                </ul>
              </td>
              <td>
                <ul v-if="property.issues && property.issues.length > 0">
                  <li
                    v-for="(issue, index) in property.issues"
                    :key="index"
                  >
                    {{ issue.message }}
                    <button
                      v-if="canAddRule &&
                        (issue.type == 'location-unresolvable' || issue.type == 'location-unambiguous' || issue.type == 'type-unresolved')"
                      @click="openRuleAddition( property.property.agentRef, property.property.uniqueId, issue )"
                      class="btn btn-link"
                    >
                      + add rule
                    </button>
                    <button
                      v-if="canAddRule &&
                        (issue.type == 'location-unresolvable' || issue.type == 'location-unambiguous') && property.intermediary.latitude && property.intermediary.longitude"
                      @click="openRuleWithLocationSuggestion( property, issue )"
                      class="btn btn-link"
                    >
                      + add location rule from lat/lng
                    </button>
                    <button
                      v-if="canAddRule &&
                        (issue.type == 'location-unresolvable' || issue.type == 'location-unambiguous')"
                      @click="openRuleWithLocationSuggestionViaGeocoding( property, issue )"
                      class="btn btn-link"
                    >
                      + add location via geocoding
                    </button>
                    <button
                      v-if="canAddRule &&
                        (issue.type == 'location-unresolvable' || issue.type == 'location-unambiguous')"
                      @click="openLocationSuggestionViaAI( property )"
                      class="btn btn-link"
                    >
                      + add location via ai
                    </button>
                    <button
                      v-if="canAddRule && issue.type == 'type-unresolved' && hasSufficientDescription( property )"
                      @click="openRuleWithTypeSuggestion( property, issue )"
                      class="btn btn-link"
                    >
                      + add type rule with ai
                    </button>
                  </li>
                </ul>
                <button
                  v-if="property.issues && property.issues.some(issue => issue.type == 'description-cleanup' )"
                  class="btn btn-link"
                  @click.prevent="cleanCache( property )"
                >
                  clean description again at next run
                </button>
                <button
                  v-if="canAddRule && hasSufficientDescription( property )"
                  @click="openPanelWithSuggestedFeatures( property )"
                  class="btn btn-link"
                >
                  + add feature rule with ai
                </button>
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-link"
                  @click.prevent="selectedPreview = property.original"
                  v-if="property.original && property.original.agent"
                >
                  xml
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  @click.prevent="selectedPreview = property.intermediary"
                  v-if="!(property.original && property.original.agent)"
                >
                  xml
                </button>
                <br>
                <button
                  type="button"
                  class="btn btn-link"
                  v-if="property.property"
                  @click.prevent="selectedPreview = property.property"
                >
                  final
                </button>
                <br>
                <button
                  type="button"
                  class="btn btn-link"
                  v-if="property.intermediary && canViewRule"
                  @click.prevent=" showMatchingRules( property )"
                >
                  rules {{ property.matchingRulesCount == null ? '(?)' : '(' + property.matchingRulesCount + ')' }}
                </button>
                <br>
                <button
                  type="button"
                  class="btn btn-link"
                  v-if="property.intermediary && canAddRule"
                  @click.prevent=" openRuleAdditionFromIntermediary( property.intermediary )"
                >
                  add rule
                </button>
                <br>
                <button
                  type="button"
                  class="btn btn-link"
                  v-if="property.intermediary && property.property"
                  @click.prevent="selectDescriptionDiff( property );"
                >
                  description diff
                </button>
                <br>
                <button
                  v-if="property.status == 'online'"
                  type="button"
                  class="btn btn-link"
                  @click.prevent="openProperty( property )"
                >
                  open
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav v-if="report && report.totalProperties > take">
          <ul class="pagination flex-wrap">
            <li
              :class="skip == take * (i - 1) ? 'page-item active' : 'page-item'"
              v-for="i in Math.ceil(report.totalProperties / take)"
              :key="i"
            >
              <a
                class="page-link"
                @click.prevent="skip = take * (i - 1);updateReport()"
                href=""
              >{{ i }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div
        :class="`modal fade px-0 ${allPhotosMode ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
        v-if="selectedProperty"
      >
        <div
          class="modal-dialog"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                All photos
              </h5>
              <button
                type="button"
                class="close"
                @click="allPhotosMode = false;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <div
                v-for="photo in selectedProperty.property.photos"
                :key="photo.url"
                style="display: inline-block; text-align: center; margin: 4px;"
              >
                <img
                  :src="photo.url"
                  :alt="photo.number"
                  height="160"
                  style="padding: 4px;"
                >
                <br>
                <a
                  @click.prevent="allPhotosMode = false; ignorePhotoMode = true; ignorePhotoUrl = photo.url;"
                  href=""
                >
                  Ignore this & similar photo
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${ignorePhotoMode ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
        v-if="ignorePhotoUrl"
      >
        <div
          class="modal-dialog"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Ignore similarly looking photos
              </h5>
              <button
                type="button"
                class="close"
                @click="allPhotosMode = true;ignorePhotoMode = false;ignorePhotoUrl = null;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <p>
                Are you sure you want to ignore this photo and all similar photos?
                <br>
                This rule is exteremely expensive as it is using visual comparison of photos and thus should be used only if you are absolutely sure that these photos are not using similarly looking urls.
              </p>
              <img
                :src="ignorePhotoUrl"
                height="160"
                style="padding: 4px;"
              >
              <br>
              <textarea
                class="form-control"
                rows="3"
                v-model="ignorePhotoReason"
                placeholder="Reason for ignoring this photo"
              />
              <button
                class="btn btn-primary"
                @click="ignorePhoto( ignorePhotoUrl )"
              >
                Ignore
              </button>
              <button
                class="btn btn-secondary"
                @click="allPhotosMode = true;ignorePhotoMode = false;ignorePhotoUrl = null;"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${selectedPreview ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
          style="max-width: 700px;"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Json preview
              </h5>
              <button
                type="button"
                class="close"
                @click="selectedPreview = null;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <pre
                class="flex-wrap"
                style="text-align: left;"
                v-html="JSON.stringify(selectedPreview, null, 4)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${createRuleMode ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Create rule
              </h5>
              <button
                type="button"
                class="close"
                @click="createRuleMode = false;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <h5>
                Conditions
              </h5>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Login</label>
                <div
                  class="col-sm-9"
                >
                  <div
                    v-for="(ruleLogin, index) in newRule.filter.agent"
                    :key="index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="newRule.filter.agent[index]"
                      :key="index"
                    >
                  </div>
                  <button
                    v-if="newRule.filter.agent.length > 0"
                    @click="newRule.filter.agent.pop();"
                    class="btn btn-link"
                  >
                    [-]
                  </button>
                  <button
                    @click="newRule.filter.agent.push( '' );"
                    class="btn btn-link"
                  >
                    [+]
                  </button>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Agent Ref.</label>
                <div
                  class="col-sm-9"
                >
                  <div
                    v-for="(ruleAgentRef, index) in newRule.filter.ref"
                    :key="index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="newRule.filter.ref[index]"
                      :key="index"
                    >
                  </div>
                  <button
                    v-if="newRule.filter.ref.length > 0"
                    @click="newRule.filter.ref.pop();"
                    class="btn btn-link"
                  >
                    [-]
                  </button>
                  <button
                    @click="newRule.filter.ref.push( '' );"
                    class="btn btn-link"
                  >
                    [+]
                  </button>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Id in feed (unique_id)</label>
                <div
                  class="col-sm-9"
                >
                  <div
                    v-for="(agentUniqueId, index) in newRule.filter.uniqueId"
                    :key="index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="newRule.filter.uniqueId[index]"
                      :key="index"
                    >
                  </div>
                  <button
                    v-if="newRule.filter.uniqueId.length > 0"
                    @click="newRule.filter.uniqueId.pop();"
                    class="btn btn-link"
                  >
                    [-]
                  </button>
                  <button
                    @click="newRule.filter.uniqueId.push( '' );"
                    class="btn btn-link"
                  >
                    [+]
                  </button>
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Type</label>
                <div
                  class="col-sm-9"
                >
                  <div
                    v-for="(val, index) in newRule.filter.type"
                    :key="index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="newRule.filter.type[index]"
                      :key="index"
                    >
                  </div>
                  <button
                    v-if="newRule.filter.type.length > 0"
                    @click="newRule.filter.type.pop();"
                    class="btn btn-link"
                  >
                    [-]
                  </button>
                  <button
                    @click="newRule.filter.type.push( '' );"
                    class="btn btn-link"
                  >
                    [+]
                  </button>
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">SubLocality</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.filter.subLocality"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Locality</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.filter.locality"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Municipality</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.filter.municipality"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Province</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.filter.province"
                  >
                </div>
              </div>
              <h5>
                Update
              </h5>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Type</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.type"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Feature</label>
                <div
                  class="col-sm-9"
                >
                  <div
                    v-for="(val, index) in newRule.update.feature"
                    :key="index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="newRule.update.feature[index]"
                      :key="index"
                    >
                  </div>
                  <button
                    v-if="newRule.update.feature.length > 0"
                    @click="newRule.update.feature.pop();"
                    class="btn btn-link"
                  >
                    [-]
                  </button>
                  <button
                    @click="newRule.update.feature.push( '' );"
                    class="btn btn-link"
                  >
                    [+]
                  </button>
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Features to remove</label>
                <div
                  class="col-sm-9"
                >
                  <div
                    v-for="(val, index) in newRule.update.featureToRemove"
                    :key="index"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="newRule.update.featureToRemove[index]"
                      :key="index"
                    >
                  </div>
                  <button
                    v-if="newRule.update.featureToRemove.length > 0"
                    @click="newRule.update.featureToRemove.pop();"
                    class="btn btn-link"
                  >
                    [-]
                  </button>
                  <button
                    @click="newRule.update.featureToRemove.push( '' );"
                    class="btn btn-link"
                  >
                    [+]
                  </button>
                </div>
              </div>

              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Province</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.province"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Municipality</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.municipality"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Locality</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.locality"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">SubLocality</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.subLocality"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Street name</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.streetName"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Street number</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.streetNumber"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Postal Code</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.postCode"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Floor number</label>
                <div
                  class="col-sm-9"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="newRule.update.floorNumber"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Ignore during import</label>
                <div
                  class="col-sm-9"
                  style="text-align: left !important;"
                >
                  <input
                    type="checkbox"
                    class="form-control-sm"
                    v-model="newRule.update.ignoreDuringImport"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Default Offer (if not present)</label>
                <div
                  class="col-sm-9"
                  style="text-align: left !important;"
                >
                  <select
                    type="checkbox"
                    class="form-control-sm"
                    v-model="newRule.update.defaultOffer"
                  >
                    <option value="">
                      Select
                    </option>
                    <option value="for-sale">
                      For sale
                    </option>
                    <option value="for-rent">
                      For rent
                    </option>
                    <option value="for-holidays">
                      For holidays
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Append offer (-SALE, -RENT, etc) to unique id</label>
                <div
                  class="col-sm-9"
                  style="text-align: left !important;"
                >
                  <input
                    type="checkbox"
                    class="form-control-sm"
                    v-model="newRule.update.appendOfferToUniqueID"
                  >
                </div>
              </div>
              <div
                class="form-group row"
                v-if="!newRuleDoNotCleanupDescription"
              >
                <label class="col-sm-3 col-form-label">Overwrite agent ref from unique id</label>
                <div
                  class="col-sm-9"
                  style="text-align: left !important;"
                >
                  <input
                    type="checkbox"
                    class="form-control-sm"
                    v-model="newRule.update.forcePopulateAgentRefFromUniqueID"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Do NOT cleanup descriptions</label>
                <div
                  class="col-sm-9"
                  style="text-align: left !important;"
                >
                  <input
                    type="checkbox"
                    class="form-control-sm"
                    v-model="newRuleDoNotCleanupDescription"
                  >
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Notes</label>
                <div
                  class="col-sm-9"
                >
                  <textarea
                    class="form-control"
                    v-model="newRule.note"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3" />
                <div
                  class="col-sm-9"
                >
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="addRule"
                  >
                    Add rule
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${propertyDescriptionDiff ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
          style="max-width: 80%;"
          v-if="propertyDescriptionDiff"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Before & After Cleanup
              </h5>
              <button
                type="button"
                class="close"
                @click="propertyDescriptionDiff = null;propertyDescriptionDiffLanguage = null;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid">
              Select language:
              <button
                v-for="language in propertyDescriptionDiffLanguages"
                :key="language"
                @click="propertyDescriptionDiffLanguage = language"
                style="margin: 4px;"
              >
                {{ language }}
              </button>
              <CodeDiff
                v-if="propertyDescriptionDiffLanguage"
                filename="before"
                new-filename="after"
                diff-style="char"
                :old-string="propertyDescriptionDiff.intermediary.description[ propertyDescriptionDiffLanguage ]"
                :new-string="propertyDescriptionDiff.property.description[ propertyDescriptionDiffLanguage ]"
                output-format="side-by-side"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${matchingRules ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
          style="min-width: 1200px;"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Matching rules
              </h5>
              <button
                type="button"
                class="close"
                @click="matchingRules = null;rulesApplied = [];"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <div
                v-if="matchingRules && matchingRules.length == 0"
                class="alert alert-info"
              >
                No matching rules
              </div>
              <table
                class="table table-striped"
                v-if="matchingRules && matchingRules.length > 0"
              >
                <thead>
                  <th>Id</th>
                  <th>Applied</th>
                  <th>Type</th>
                  <th>Rule</th>
                  <th>Created By</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </thead>
                <tbody>
                  <tr
                    v-for="rule in matchingRules"
                    :key="rule.id"
                  >
                    <td>{{ rule.id }}</td>
                    <td>
                      <span
                        :class="`badge badge-pill badge-${rulesApplied.includes( rule.id ) ? 'success' : 'primary' }`"
                      >
                        {{ rulesApplied.includes( rule.id ) ? 'applied' : 'new' }}
                      </span>
                    </td>
                    <td>{{ rule.ruleType }}</td>
                    <td>
                      <pre
                        style="text-align: left;"
                        v-html="JSON.stringify(JSON.parse(rule.rule), null, 2)"
                      />
                    </td>
                    <td>{{ rule.createdBy }}</td>
                    <td>{{ toLocaleString( rule.createdAt ) }}</td>
                    <td>
                      <button
                        class="btn btn-outline-secondary"
                        v-if="canRemoveRule"
                        @click="removeRule ( rule.id )"
                      >
                        remove rule
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${suggestFeatureMode ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
          style="max-width: 700px;"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Suggested extra features
              </h5>
              <button
                type="button"
                class="close"
                @click="suggestFeatureMode = false;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <div
                v-if="suggestedFeaturesProperty && suggestedFeaturesProperty.property && suggestedFeaturesProperty.property.features"
              >
                Current features based on xml data: {{ suggestedFeaturesProperty.property.features.join(', ') }}
              </div>
              <div
                v-if="suggestedFeatures && suggestedFeatures.length == 0"
                class="alert alert-info"
              >
                No suggested features
              </div>
              <table
                class="table table-striped"
                v-if="suggestedFeatures && suggestedFeatures.length > 0"
              >
                <thead>
                  <th>Feature</th>
                  <th>Quotation (as in description)</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  <tr
                    v-for="feature in suggestedFeatures"
                    :key="feature.feature"
                  >
                    <td>{{ feature.feature }}</td>
                    <td>{{ feature.quotation }}</td>
                    <td>
                      <button
                        class="btn btn-outline-secondary"
                        @click="removeSuggestedFeature ( feature.feature )"
                      >
                        remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                class="btn btn-primary"
                :disabled="!suggestedFeatures || suggestedFeatures.length == 0"
                @click="openRuleWithFeatureSuggestion"
              >
                Add all
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${suggestLocationMode ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
          style="max-width: 700px;"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Suggested location
              </h5>
              <button
                type="button"
                class="close"
                @click="suggestLocationMode = false;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <div
                v-if="suggestedLocationProperty && suggestedLocationProperty.intermediary.description"
              >
                <dl class="row text-left">
                  <dt class="col-sm-3">
                    Description
                  </dt>
                  <dd class="col-sm-9">
                    <blockquote
                      v-html="getDescriptionSample( suggestedLocationProperty.intermediary, 1800 )"
                    />
                  </dd>
                </dl>
                <dl class="row text-left">
                  <dt class="col-sm-3">
                    Data from xml
                  </dt>
                  <dd class="col-sm-9">
                    SubLocality: {{ suggestedLocationProperty.intermediary.subLocality }}
                    <br>
                    Locality: {{ suggestedLocationProperty.intermediary.locality }}
                    <br>
                    Municipality: {{ suggestedLocationProperty.intermediary.municipality }}
                    <br>
                    Province: {{ suggestedLocationProperty.intermediary.province }}
                  </dd>
                </dl>
              </div>
              <div
                v-if="
                  !suggestedLocation
                    || !suggestedLocation.municipality
                    || suggestedLocation.municipality.length == 0
                    || !suggestedLocation.province
                    || suggestedLocation.province.length == 0"
                class="alert alert-info"
              >
                No suggested location
              </div>
              <div
                v-else
              >
                <dl class="row text-left">
                  <dt class="col-sm-3">
                    Citations
                  </dt>
                  <dd class="col-sm-9">
                    <blockquote
                      v-for="citation in suggestedLocation.citations"
                      :key="citation"
                    >
                      {{ citation }}
                    </blockquote>
                  </dd>
                </dl>
                <dl class="row text-left">
                  <dt class="col-sm-3">
                    Reasoning
                  </dt>
                  <dd class="col-sm-9">
                    {{ suggestedLocation.reasoning }}
                  </dd>
                </dl>
                <dl class="row text-left">
                  <dt class="col-sm-3">
                    Suggested location
                  </dt>
                  <dd class="col-sm-9">
                    Province: {{ suggestedLocation.province }}
                    <br>
                    Municipality: {{ suggestedLocation.municipality }}
                    <br>
                    Locality: {{ suggestedLocation.locality }}
                    <br>
                    SubLocality: {{ suggestedLocation.subLocality }}
                  </dd>
                </dl>
                <button
                  class="btn btn-primary"
                  @click="approveLocationSuggestion"
                >
                  Approve
                </button>
                <button
                  class="btn btn-secondary"
                  @click="openRuleWithLocationSuggestionWithAI"
                >
                  Create rule from resolution
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${detailedImageReportMode ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
        >
          <div
            class="modal-content"
            style="min-width: 900px;"
          >
            <div class="modal-header">
              <h5 class="modal-title">
                Detailed image report
              </h5>
              <button
                type="button"
                class="close"
                @click="detailedImageReportMode = false;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <table
                v-if="imageReport"
                class="table table-striped"
              >
                <thead
                  style="position: sticky;top:0;background:white"
                >
                  <th>Property</th>
                  <th>Agent Ref</th>
                  <th>Images</th>
                  <th>Invalid</th>
                  <th>Processed</th>
                  <th>Processed ok</th>
                  <th>Pending table sync</th>
                </thead>
                <tbody>
                  <tr
                    v-for="(propertyImageReport, idx) in imageReport"
                    :key="idx"
                    :class="(propertyImageReport.total > 0 && propertyImageReport.total == propertyImageReport.invalid) ? 'table-danger' : (propertyImageReport.total == 0 || propertyImageReport.invalid > 0 || propertyImageReport.total > propertyImageReport.ok) ? 'table-warning' : ''"
                  >
                    <td>{{ propertyImageReport.propertyId }}</td>
                    <td>{{ propertyImageReport.agentRef }}</td>
                    <td>{{ propertyImageReport.total }}</td>
                    <td>{{ propertyImageReport.invalid }}</td>
                    <td>{{ propertyImageReport.processed }}</td>
                    <td>{{ propertyImageReport.ok }}</td>
                    <td>{{ propertyImageReport.pendingTableSync }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`modal fade px-0 ${invalidImagesReportMode ? 'show d-block' : 'd-none'}`"
        tabindex="-1"
        role="dialog"
      >
        <div
          class="modal-dialog"
          role="document"
        >
          <div
            class="modal-content"
            style="min-width: 900px;"
          >
            <div class="modal-header">
              <h5 class="modal-title">
                Failed images report (first 200 images)
              </h5>
              <button
                type="button"
                class="close"
                @click="invalidImagesReportMode = false;"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body container-fluid text-center">
              <div
                v-if="invalidImages && invalidImages.length == 0"
                class="alert alert-info"
              >
                No failed images found
              </div>
              <table
                v-if="invalidImages && invalidImages.length > 0"
                class="table table-striped"
              >
                <thead>
                  <th>Property</th>
                  <th>Number</th>
                  <th>Origin</th>
                  <th>Last Checked</th>
                  <th>Last Checked Status</th>
                  <th>Last Checked Message</th>
                  <th>Failed Attempts</th>
                  <th>Next Check</th>
                </thead>
                <tbody>
                  <tr
                    v-for="(image, idx) in invalidImages"
                    :key="idx"
                  >
                    <td>{{ image.propertyId }}</td>
                    <td>{{ image.number }}</td>
                    <td>{{ image.originUrl }}</td>
                    <td>{{ toLocaleString( image.lastChecked ) }}</td>
                    <td>{{ image.lastCheckedStatus }}</td>
                    <td>{{ image.lastCheckedMessage }}</td>
                    <td>{{ image.failedAttempts }}</td>
                    <td>{{ toLocaleString( image.nextScheduledReprocess ) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CodeDiff } from 'v-code-diff';

import { hasPolicyWithAnyAction } from '../../../auth/index';
import store from '../../../store';
import xmlimportsapi from '../../../xmlimportapi';
import adminapi from '../../../http';
import geospatialapi from '../../../geospatialapi';
import notify from '../../../notifications';
import collections from '../../../collections';

let preloadedLocations = {};

function newRule() {
    return {
        filter: {
            agent: [],
            ref: [],
            uniqueId: [],
            type: [],
            subLocality: '',
            locality: '',
            municipality: '',
            province: ''
        },
        update: {
            type: '',
            feature: [],
            featureToRemove: [],
            floorNumber: '',
            subLocality: '',
            locality: '',
            municipality: '',
            province: '',
            streetName: '',
            streetNumber: '',
            postCode: '',
            ignoreDuringImport: false,
            appendOfferToUniqueID: false,
            forcePopulateAgentRefFromUniqueID: false,
            cleanupDescriptions: null,
            defaultOffer: ''
        }
    };
}

export default {
    components: {
        CodeDiff
    },
    props: {
        reportEntry: {
            type: Object,
            default: () => null
        },
        showCloseButton: {
            type: Boolean,
            default: true
        },
        showReprocessAction: {
            type: Boolean,
            default: true
        },
        recalculateWithImageReport: {
            type: Boolean,
            default: false
        }
    },
    emits: [ 'close' ],
    watch: {
        reportEntry: {
            async handler( val ) {
                this.skip = 0;
                this.statusFilters = [ 'invalid' ];
                this.errorFilters = [];
                this.agentRefFilter = '';
                this.ourIdFilter = null;
                this.issueFilter = '';
                this.imageReport = null;
                this.invalidImages = null;
                this.matchingRules = null;
                this.rulesApplied = [];
                this.propertyResolutionJob = null;
                this.propertyLocationResolutionJob = null;
                if ( !val ) {
                    this.report = null;
                    return;
                }
                await this.updateReport( );
            }
        }
    },
    data() {
        return {
            processing: false,
            report: null,
            statusFilters: [ 'invalid' ],
            agentRefFilter: '',
            ourIdFilter: null,
            issueFilter: '',
            errorFilters: [],
            propertyTypes: [],
            createRuleMode: false,
            propertyDescriptionDiff: null,
            propertyDescriptionDiffLanguage: null,
            newRule: newRule(),
            newRuleDoNotCleanupDescription: false,
            allPhotosMode: false,
            ignorePhotoMode: false,
            ignorePhotoUrl: null,
            ignorePhotoReason: '',
            selectedProperty: null,
            selectedPreview: null,
            matchingRules: null,
            rulesApplied: [],
            skip: 0,
            take: 20,
            imageReport: null,
            invalidImages: null,
            suggestFeatureMode: false,
            suggestLocationMode: false,
            detailedImageReportMode: false,
            invalidImagesReportMode: false,
            suggestedLocation: null,
            suggestedLocationProperty: null,
            suggestedFeatures: [],
            suggestedFeaturesProperty: null,
            propertyResolutionJob: null,
            propertyLocationResolutionJob: null,
            reprocessFailedImagesStarted: false,
            reprocessImagesStarted: false
        };
    },
    async mounted() {
        this.propertyTypes = collections.propertyTypes();
    },
    computed: {
        canViewRule() {
            return hasPolicyWithAnyAction( store.state.user, 'xml-import-rule:*', 'xml-import-rule:read' );
        },
        canAddRule() {
            return hasPolicyWithAnyAction( store.state.user, 'xml-import-rule:*', 'xml-import-rule:write' );
        },
        canReprocessFailedImages() {
            return hasPolicyWithAnyAction( store.state.user, 'photoprocessing:*', `photoprocessing:${this.reportEntry.agentCode}:*`, `photoprocessing:${this.reportEntry.agentCode}:reprocess` );
        },
        canReprocessImages() {
            return hasPolicyWithAnyAction( store.state.user, 'photoprocessing:*', `photoprocessing:${this.reportEntry.agentCode}:*`, `photoprocessing:${this.reportEntry.agentCode}:reprocess` );
        },
        canRemoveRule() {
            return hasPolicyWithAnyAction( store.state.user, 'xml-import-rule:*', 'xml-import-rule:write' );
        },
        canRunImport() {
            return hasPolicyWithAnyAction( store.state.user, 'xml-import:*', 'xml-import:*:run', `xml-import:${this.reportEntry.agentCode}:*`, `xml-import:${this.reportEntry.agentCode}:run` );
        },
        publicWithAllImagesInvalid() {
            return this.imageReport.filter( p => p.total > 0 && p.valid == 0 && p.invalid == p.total ).length;
        },
        publicWithNoValidImagesButSomeInProgress() {
            return this.imageReport.filter( p => p.total > 0 && p.valid == 0 && p.invalid < p.total ).length;
        },
        propertyDescriptionDiffLanguages() {
            if ( !this.propertyDescriptionDiff ) {
                return [];
            }
            const intermediaryLangs = Object.keys( this.propertyDescriptionDiff.intermediary.description || {} );
            const propertyLangs = Object.keys( this.propertyDescriptionDiff.property.description || {} );
            const languages = [ ...new Set( [ ...intermediaryLangs, ...propertyLangs ] ) ]; // Merge and remove duplicates
            return languages;
        }
    },
    methods: {
        async selectDescriptionDiff( property ) {
            this.propertyDescriptionDiff = property;

            let langs = this.propertyDescriptionDiffLanguages;

            if ( langs.length > 0 ) {
                this.propertyDescriptionDiffLanguage = langs[ 0 ];
            }
        },
        async resolveAllPropertyTypes() {
            this.$store.dispatch( 'appLoading', true );

            let url = `propertytyperulesfromrun/${this.reportEntry.agentCode}/${this.reportEntry.id}`;

            const response = await xmlimportsapi.post( url );

            if ( response.status !== 200 && response.status !== 202 && response.status !== 409 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to resolve property types'
                } );
                return;
            }

            if ( response.status === 202 ) {
                this.propertyResolutionJob = 'Job started, please wait';
                return;
            }

            let jobId;

            // conflict usually means there is a job running
            if ( response.status === 409 ) {
                jobId = 'type:' + this.reportEntry.id;
            } else {
                let jsonResult = await response.json();
                jobId = jsonResult.jobId;
            }

            let checkJobStatus = async () => {
                const response = await xmlimportsapi.get( `job/${jobId}` );

                if ( response.status !== 200 ) {
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to resolve property types'
                    } );
                    clearInterval( intervalId ); // Stop the interval
                    return;
                }

                let jobStatus = await response.json();

                this.propertyResolutionJob = jobStatus;

                if ( jobStatus.completed ) {
                    clearInterval( intervalId );
                    return;
                }
            };

            // Run the function once immediately
            checkJobStatus();

            this.$store.dispatch( 'appLoading', false );

            // Then run it every 2 seconds
            let intervalId = setInterval( checkJobStatus, 2000 );
        },
        async ignorePhoto( url ) {
            // creates a rule to ignore the photo, passes {agent, url}
            this.$store.dispatch( 'appLoading', true );

            let toSend = {
                agent: this.reportEntry.agentCode,
                url: url,
                note: this.ignorePhotoReason
            };

            const response = await xmlimportsapi.post( '/imageignorerule', toSend );

            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ignore photo'
                } );
                return;
            } else {
                notify( {
                    type: 'success',
                    text: 'Rule added successfully',
                    title: 'Rule added'
                } );
            }

            this.ignorePhotoMode = false;
            this.ignorePhotoUrl = null;
            this.ignorePhotoReason = '';
            this.allPhotosMode = true;
        },
        async resolveAllPropertyLocations() {
            this.$store.dispatch( 'appLoading', true );

            let url = `propertylocationrulesfromrun/${this.reportEntry.agentCode}/${this.reportEntry.id}`;

            const response = await xmlimportsapi.post( url );

            if ( response.status !== 200 && response.status !== 202 && response.status !== 409 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to resolve property types'
                } );
                return;
            }

            if ( response.status === 202 ) {
                this.propertyLocationResolutionJob = 'Job started, please wait';
                return;
            }

            let jobId;

            // conflict usually means there is a job running
            if ( response.status === 409 ) {
                jobId = 'location:' + this.reportEntry.id;
            } else {
                let jsonResult = await response.json();
                jobId = jsonResult.jobId;
            }

            let checkJobStatus = async () => {
                const response = await xmlimportsapi.get( `job/${jobId}` );

                if ( response.status !== 200 ) {
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to resolve property types'
                    } );
                    clearInterval( intervalId ); // Stop the interval
                    return;
                }

                let jobStatus = await response.json();

                this.propertyLocationResolutionJob = jobStatus;

                if ( jobStatus.completed ) {
                    clearInterval( intervalId );
                    return;
                }
            };

            // Run the function once immediately
            checkJobStatus();

            this.$store.dispatch( 'appLoading', false );

            // Then run it every 2 seconds
            let intervalId = setInterval( checkJobStatus, 2000 );
        },
        async reprocessFailedImages() {
            return this.reprocessImages( false );
        },
        async reprocessImages( checkForModifiedPhotos ) {
            let url = '/photoprocessing/' + this.reportEntry.agentCode + '/reprocess';

            if ( checkForModifiedPhotos ) {
                url += '?checkForModifiedPhotos=true';
            }

            const response = await adminapi.post( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load image report'
                } );
                return;
            }

            if ( checkForModifiedPhotos ) {
                this.reprocessImagesStarted = true;
            } else {
                this.reprocessFailedImagesStarted = true;
            }
        },

        removeSuggestedFeature( feature ) {
            this.suggestedFeatures = this.suggestedFeatures.filter( f => f.feature !== feature );
        },
        async agentRefFilterChanges() {
            await this.updateReport();
        },
        linkToProperties( entry ) {
            return `${process.env.THINKSPAIN_URL}/property-for-sale?filteroffers=all&login=${entry.agentCode}&order=RecentFirst`;
        },
        validPromotion( entry ) {
            if ( !entry.runConfig.promotionStartDate || !entry.runConfig.promotionEndDate ) {
                return false;
            }
            const promotionStartDate = new Date( entry.runConfig.promotionStartDate );
            const promotionEndDate = new Date( entry.runConfig.promotionEndDate );

            const start = new Date( entry.start );

            return start >= promotionStartDate && start <= promotionEndDate;
        },
        order( entry ) {
            if ( !entry.runConfig.sortType ) {
                return '';
            }

            switch ( entry.runConfig.sortType ) {
            case 0:
                return 'with photos, as in the feed';
            case 1:
                return 'with photos, date descending';
            case 2:
                return 'with photos, price ascending';
            case 3:
                return 'with photos, price descending';
            case 4:
                return 'manual';
            case 5:
                return 'custom';
            default:
                return 'unknown';
            }
        },
        async loadImageReport() {
            let url = '/photo-report-detailed/' + this.reportEntry.agentCode;

            const response = await adminapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load image report'
                } );
                return;
            }

            var imageReport = await response.json();

            // sorting - first invalid, then warning, then ok

            function compareImageReport( first, second ) {
                let isFirstoffline = ( first.total > 0 && first.total == first.invalid );
                let isSecondoffline = ( second.total > 0 && second.total == second.invalid );

                if ( isFirstoffline && !isSecondoffline ) {
                    return -1;
                }

                if ( !isFirstoffline && isSecondoffline ) {
                    return 1;
                }

                let isFirstWarning = ( first.total == 0 || first.invalid > 0 || first.total > first.ok );
                let isSecondWarning = ( second.total == 0 || second.invalid > 0 || second.total > second.ok );

                if ( isFirstWarning && !isSecondWarning ) {
                    return -1;
                }

                if ( !isFirstWarning && isSecondWarning ) {
                    return 1;
                }

                return 0;
            }

            imageReport = imageReport || [];

            imageReport.sort( compareImageReport );

            this.imageReport = imageReport;
        },
        async loadInvalidImages() {
            this.$store.dispatch( 'appLoading', true );

            let url = '/photo-report/invalid/' + this.reportEntry.agentCode;

            const response = await adminapi.get( url );

            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load image report'
                } );
                return;
            }

            let result = ( await response.json() ) || [];

            this.invalidImages = result;
        },
        async updateReport( ) {
            this.$store.dispatch( 'appLoading', true );

            this.loadImageReport();

            let url = `report/${this.reportEntry.agentCode}/${this.reportEntry.id}?skip=${this.skip}&take=${this.take}`;

            this.statusFilters.forEach( statusFilter => {
                url += '&status=' + statusFilter;
            } );

            this.errorFilters.forEach( statusFilter => {
                url += '&error=' + statusFilter;
            } );

            if ( this.agentRefFilter ) {
                url += '&agentref=' + this.agentRefFilter;
            }

            if ( this.issueFilter ) {
                url += '&issue=' + this.issueFilter;
            }

            if ( this.ourIdFilter ) {
                // get agentRef from ourid
                const response = await xmlimportsapi.get( `property?login=${this.reportEntry.agentCode}&id=${this.ourIdFilter}` );

                if ( response.status !== 200 ) {
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to load report'
                    } );
                    this.$store.dispatch( 'appLoading', false );
                    return;
                }

                const propertiesFromApi = await response.json();

                // if no property found, add a unique id that won't exist
                if ( propertiesFromApi.length == 0 ) {
                    url += '&uniqueid=thisuniqueidwontexists599fuf738H93$&agentref=thisaswelljustdoublecheck';
                } else {
                    url += `&uniqueid=${propertiesFromApi[ 0 ].uniqueId}&agentref=${propertiesFromApi[ 0 ].agentRef}`;
                }
            }

            const response = await xmlimportsapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load report'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            let report = await response.json();
            for ( let property of report.properties ) {
                property.matchingRulesCount = null;
            }
            this.populateMatchingRules( report );
            var locs = this.preloadLocations( report );
            await locs;
            this.report = report;

            this.$store.dispatch( 'appLoading', false );
        },
        toLocaleString( dateInString ) {
            if ( !dateInString ) {
                return '';
            }
            const date = new Date( dateInString );

            return date.toLocaleString( [ 'es-ES', 'en-UK' ] );
        },
        getStatus( status ) {
            switch ( status ) {
            case 'online':
                return 'Valid';
            case 'offline':
                return 'Valid over service limit';
            case 'invalid':
                return 'Invalid';
            case 'unmatched':
                return 'Excluded';
            case 'ignored':
                return 'Ignored';
            default:
                return 'Unknown';
            }
        },
        getDescriptionSample( property, max ) {
            if ( !max ) {
                max = 600;
            }

            if ( !property || !property.description ) {
                return '';
            }

            let description = property.description[ 'en' ];
            if ( !description ) {
                description = property.description[ 'es' ];
            } else if ( description.length < 20 && property.description[ 'es' ] ) {
                description += '<br><br>es:<br>' + property.description[ 'es' ];
            }

            if ( !description ) {
                return '';
            }

            if ( description.length < max ) {
                return description;
            }

            return description.substring( 0, max ) + ' ...';
        },
        takeTop( array ) {
            if ( !array ) {
                return [];
            }
            // order by number property
            array.slice().sort( ( a, b ) => {
                return a.number - b.number;
            } );
            return array.slice( 0, 1 );
        },
        resetRule() {
            this.newRule = newRule();
        },
        async addRule( ) {
            let endpoint = '/updaterule';

            if ( this.newRuleDoNotCleanupDescription ) {
                this.newRule.update.cleanupDescriptions = 'none';
                endpoint = '/descriptioncleanuprule';
            }

            const response = await xmlimportsapi.post( endpoint, this.newRule );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to create a rule'
                } );
                return;
            }

            notify( {
                type: 'success',
                text: 'Rule added',
                title: 'Success'
            } );

            this.createRuleMode = false;
            this.resetRule();

            this.populateMatchingRules( this.report );
        },
        async populateMatchingRules( report ) {
            for ( let property of report.properties ) {
                if ( !property.intermediary ) {
                    continue;
                }

                let url = '/matchingrules/count';
                let body = { intermediary: property.intermediary, property: property.property };

                if ( property.original && property.original.agent ) {
                    url = '/matchingrulesfromoriginal/count';
                    body = { original: property.original };
                }

                const response = await xmlimportsapi.post( url, body );

                if ( response.status !== 200 ) {
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to load rules'
                    } );
                    return;
                }

                let result = await response.json();

                if ( !result ) {
                    return '';
                }

                property.matchingRulesCount = result.count;
            }
        },
        async showMatchingRules( property ) {
            if ( property.original && property.original.agent ) {
                this.showMatchingRulesFromOriginal( property );
            } else {
                this.showMatchingRulesFromIntermediary( property );
            }
        },
        async showMatchingRulesFromIntermediary( property ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/matchingrules', { intermediary: property.intermediary, property: property.property } );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load rules'
                } );
                return;
            }

            this.$store.dispatch( 'appLoading', false );

            this.rulesApplied = property.rulesApplied ? property.rulesApplied : [];
            this.matchingRules = await response.json();
        },
        async showMatchingRulesFromOriginal( property ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/matchingrulesfromoriginal', { original: property.original } );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load rules'
                } );
                return;
            }

            this.$store.dispatch( 'appLoading', false );

            this.rulesApplied = property.rulesApplied ? property.rulesApplied : [];
            this.matchingRules = await response.json();
        },
        openRuleAddition( agentRef, uniqueId, issue ) {
            this.createRuleMode = true;
            this.resetRule();
            this.newRule.filter.ref.push( agentRef );
            this.newRule.filter.uniqueId.push( uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            if ( issue.type == 'type-unresolved' ) {
                this.newRule.filter.type.push( issue.data );
            }

            if ( issue.type == 'location-unambiguous' || issue.type == 'location-unresolvable' ) {
                this.newRule.filter.subLocality = issue.data.subLocality;
                this.newRule.filter.locality = issue.data.locality;
                this.newRule.filter.municipality = issue.data.municipality;
                this.newRule.filter.province = issue.data.province;
            }
        },
        hasSufficientDescription( property ) {
            if ( !property ) {
                return false;
            }

            if ( !property.intermediary ) {
                return false;
            }

            let description = property.intermediary.description[ 'en' ];

            if ( !description || description.length < 50 ) {
                description = property.intermediary.description[ 'es' ];
            }

            return description && description.length > 50;
        },
        async openRuleWithTypeSuggestion( property, issue ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/suggesttype', property.intermediary );
            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ask ai about a rule'
                } );
                return;
            }
            var suggestedType = await response.json();
            this.createRuleMode = true;
            this.resetRule();
            this.newRule.filter.ref.push( property.property.agentRef );
            this.newRule.filter.uniqueId.push( property.property.uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            if ( issue.type == 'type-unresolved' && issue.data ) {
                this.newRule.filter.type.push( issue.data );
            }

            if ( suggestedType.type && suggestedType.type.toLowerCase() != 'other' ) {
                this.newRule.update.type = suggestedType.type;
            }
        },
        async openRuleWithFeatureSuggestion( ) {
            this.suggestFeatureMode = false;
            this.createRuleMode = true;
            this.resetRule();
            this.newRule.filter.ref.push( this.suggestedFeaturesProperty.property.agentRef );
            this.newRule.filter.uniqueId.push( this.suggestedFeaturesProperty.property.uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            for ( let feature of this.suggestedFeatures ) {
                this.newRule.update.feature.push( feature.feature );
            }
        },
        async openRuleWithLocationSuggestionWithAI( ) {
            this.suggestLocationMode = false;
            this.createRuleMode = true;
            this.resetRule();
            this.newRule.filter.ref.push( this.suggestedLocationProperty.intermediary.agentRef );
            this.newRule.filter.uniqueId.push( this.suggestedLocationProperty.intermediary.uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            if ( this.suggestedLocationProperty.intermediary.subLocality ) {
                this.newRule.filter.subLocality = this.suggestedLocationProperty.intermediary.subLocality;
            }

            if ( this.suggestedLocationProperty.intermediary.locality ) {
                this.newRule.filter.locality = this.suggestedLocationProperty.intermediary.locality;
            }

            if ( this.suggestedLocationProperty.intermediary.municipality ) {
                this.newRule.filter.municipality = this.suggestedLocationProperty.intermediary.municipality;
            }

            if ( this.suggestedLocationProperty.intermediary.province ) {
                this.newRule.filter.province = this.suggestedLocationProperty.intermediary.province;
            }

            if ( this.suggestedLocation.province ) {
                this.newRule.update.province = this.suggestedLocation.province;
            }

            if ( this.suggestedLocation.municipality ) {
                this.newRule.update.municipality = this.suggestedLocation.municipality;
            }

            if ( this.suggestedLocation.locality ) {
                this.newRule.update.locality = this.suggestedLocation.locality;
            }

            if ( this.suggestedLocation.subLocality ) {
                this.newRule.update.subLocality = this.suggestedLocation.subLocality;
            }
        },
        async openPanelWithSuggestedFeatures( property ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/suggestfeature', property.intermediary );
            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ask ai about a rule'
                } );
                return;
            }
            this.suggestedFeatures = await response.json();
            this.suggestFeatureMode = true;
            this.suggestedFeaturesProperty = property;
        },
        async openRuleWithLocationSuggestion( property, issue ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/suggestlocationfromlatlng', property.intermediary );
            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ask ai about a rule'
                } );
                return;
            }
            var suggestedLocation = await response.json();
            this.createRuleMode = true;
            this.resetRule();
            this.newRule.filter.ref.push( property.property.agentRef );
            this.newRule.filter.uniqueId.push( property.property.uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            if ( issue.data ) {
                this.newRule.filter.subLocality = issue.data.subLocality;
                this.newRule.filter.locality = issue.data.locality;
                this.newRule.filter.municipality = issue.data.municipality;
                this.newRule.filter.province = issue.data.province;
            }

            if ( !suggestedLocation ) {
                return;
            }

            this.newRule.update.subLocality = suggestedLocation.subLocality;
            this.newRule.update.locality = suggestedLocation.locality;
            this.newRule.update.municipality = suggestedLocation.municipality;
            this.newRule.update.province = suggestedLocation.province;
        },
        async openLocationSuggestionViaAI( property ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/suggestlocationviaai', property.intermediary );
            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ask ai about location suggestion'
                } );
                return;
            }
            this.suggestedLocation = await response.json();
            this.suggestLocationMode = true;
            this.suggestedLocationProperty = property;
        },
        async cleanCache( property ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/clearcacheddescription', { login: this.reportEntry.agentCode, agentref: property.property.agentRef } );
            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ask ai about location suggestion'
                } );
                return;
            }

            notify( {
                type: 'success',
                text: 'Scheduled for description cleaning',
                title: 'Success'
            } );
        },
        async cleanCacheForRun( runId ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/clearcacheddescription/' + runId );
            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ask ai about location suggestion'
                } );
                return;
            }

            notify( {
                type: 'success',
                text: 'Scheduled for description cleaning',
                title: 'Success'
            } );
        },
        async approveLocationSuggestion( ) {
            this.suggestLocationMode = false;

            if ( !this.suggestedLocation ) {
                return;
            }

            if ( !this.suggestedLocationProperty ) {
                return;
            }

            this.resetRule();
            this.newRule.filter.ref.push( this.suggestedLocationProperty.property.agentRef );
            this.newRule.filter.uniqueId.push( this.suggestedLocationProperty.property.uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            if ( this.suggestedLocation.province ) {
                this.newRule.update.province = this.suggestedLocation.province;
            }

            if ( this.suggestedLocation.municipality ) {
                this.newRule.update.municipality = this.suggestedLocation.municipality;
            }

            if ( this.suggestedLocation.locality ) {
                this.newRule.update.locality = this.suggestedLocation.locality;
            }

            if ( this.suggestedLocation.subLocality ) {
                this.newRule.update.subLocality = this.suggestedLocation.subLocality;
            }

            await this.addRule();

            this.suggestLocationMode = false;
            this.suggestedLocation = null;
            this.suggestedLocationProperty = null;
        },
        async openRuleWithLocationSuggestionViaGeocoding( property, issue ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await xmlimportsapi.post( '/suggestlocationviageocoding', property.intermediary );
            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to ask ai about a rule'
                } );
                return;
            }
            var suggestedLocation = await response.json();
            this.createRuleMode = true;
            this.resetRule();
            this.newRule.filter.ref.push( property.property.agentRef );
            this.newRule.filter.uniqueId.push( property.property.uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            if ( issue.data ) {
                this.newRule.filter.subLocality = issue.data.subLocality;
                this.newRule.filter.locality = issue.data.locality;
                this.newRule.filter.municipality = issue.data.municipality;
                this.newRule.filter.province = issue.data.province;
            }

            if ( !suggestedLocation ) {
                return;
            }

            this.newRule.update.subLocality = suggestedLocation.subLocality;
            this.newRule.update.locality = suggestedLocation.locality;
            this.newRule.update.municipality = suggestedLocation.municipality;
            this.newRule.update.province = suggestedLocation.province;
        },
        openRuleAdditionFromIntermediary( intermediary ) {
            this.createRuleMode = true;
            this.resetRule();
            this.newRule.filter.ref.push( intermediary.agentRef );
            this.newRule.filter.uniqueId.push( intermediary.uniqueId );
            this.newRule.filter.agent.push( this.reportEntry.agentCode );

            if ( intermediary.type ) {
                this.newRule.filter.type.push( intermediary.type );
            }

            this.newRule.filter.subLocality = intermediary.subLocality;
            this.newRule.filter.locality = intermediary.locality;
            this.newRule.filter.municipality = intermediary.municipality;
            this.newRule.filter.province = intermediary.province;
        },
        getPropertyTypeTextById( typeId ) {
            let propertyType = this.propertyTypes.filter( ( pt ) => pt.Id == typeId );

            if ( !propertyType || propertyType.length == 0 ) {
                return '';
            }

            return propertyType[ 0 ].Labels[ 'en' ];
        },
        async preloadLocations( report ) {
            let locationIDs = [];

            for ( let property of report.properties ) {
                let locationId = property.property.location.locationId;
                if ( locationId && !preloadedLocations[ locationId ] ) {
                    locationIDs.push( `id=${property.property.location.locationId}` );
                }
            }

            if ( locationIDs.length == 0 ) {
                return;
            }

            // build url or form ?id=123&id=456
            let url = '/locations?' + locationIDs.join( '&' );

            const response = await geospatialapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load locations'
                } );
                return;
            }

            const locations = await response.json();

            for ( let location of locations ) {
                preloadedLocations[ location.id ] = location;
            }
        },
        showLocation( property ) {
            const locationId = property.property.location.locationId;
            if ( !locationId ) {
                return '';
            }

            const location = preloadedLocations[ locationId ];

            if ( !location ) {
                return '';
            }

            let output = `name: ${location.labels.es}`;

            let entities = location.parentLocations.filter( p => p.type == 'entity' );
            if ( entities.length > 0 ) {
                output += `<br>entity: ${entities.map( e => e.labels.es ).join( ', ' )}`;
            }

            let districts = location.parentLocations.filter( p => p.type == 'district' );

            if ( districts.length > 0 ) {
                output += `<br>district: ${districts.map( d => d.labels.es ).join( ', ' )}`;
            }

            let neighborhoods = location.parentLocations.filter( p => p.type == 'neighborhood' );
            if ( neighborhoods.length > 0 ) {
                output += `<br>neighborhood: ${neighborhoods.map( n => n.labels.es ).join( ', ' )}`;
            }

            let municipalities = location.parentLocations.filter( p => p.type == 'municipality' );
            if ( municipalities.length > 0 ) {
                output += `<br>municipality: ${municipalities.map( m => m.labels.es ).join( ', ' )}`;
            }

            let province = location.parentLocations.filter( p => p.type == 'province' );
            if ( province.length > 0 ) {
                output += `<br>province: ${province.map( p => p.labels.es ).join( ', ' )}`;
            }

            let region = location.parentLocations.filter( p => p.type == 'region' );
            if ( region.length > 0 ) {
                output += `<br>region: ${region.map( r => r.labels.es ).join( ', ' )}`;
            }

            return output;
        },
        formatLatLngInfo( property ) {
            if ( !property.property.latitude || !property.property.longitude ) {
                return '';
            }
            return `${property.property.latitude}, ${property.property.longitude}`;
        },
        async viewRawXml( login, entryId ) {
            let url = `/report/${login}/${entryId}/xml`;

            const response = await xmlimportsapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load raw xml'
                } );
                return;
            }

            const rawXml = await response.json();

            window.open( rawXml.url, '_blank' );
        },
        async downloadRawXml( login, entryId ) {
            let url = `/report/${login}/${entryId}/xml`;

            const response = await xmlimportsapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load raw xml'
                } );
                return;
            }

            const rawXml = await response.json();

            let xmlContentRequest = await fetch( rawXml.url );

            if ( !xmlContentRequest.ok ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load raw xml from s3 server'
                } );
                return;
            }

            const blob = new Blob( [ await xmlContentRequest.text() ], { type: 'application/xml' } );
            const downloadUrl = URL.createObjectURL( blob );

            // Create a link element and trigger the download
            let a = document.createElement( 'a' );
            a.href = downloadUrl;
            a.download = `${login}-feed.xml`; // Set the desired filename
            document.body.appendChild( a );
            a.click();
            document.body.removeChild( a );

            // Revoke the object URL to free up memory
            URL.revokeObjectURL( downloadUrl );
        },
        async openProperty( property ) {
            let url = `/property?login=${ property.intermediary.agent }&uniqueid=${ property.intermediary.uniqueId }`;

            const response = await xmlimportsapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load property'
                } );
                return;
            }

            const propertiesFromApi = await response.json();

            if ( propertiesFromApi.length == 0 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load property'
                } );
                return;
            }

            window.open( process.env.THINKSPAIN_URL + `/en/redirect-to-property/${propertiesFromApi[ 0 ].id}`, '_blank' );
        },
        setFilter( statuses ) {
            if ( statuses == null || statuses.length == 0 ) {
                this.statusFilters = [];
            } else {
                for ( let status of statuses ) {
                    if ( this.statusFilters.includes( status ) ) {
                        this.statusFilters = this.statusFilters.filter( filter => filter !== status );
                    } else {
                        this.statusFilters.push( status );
                    }
                }
            }

            this.skip = 0;
            this.updateReport();
        },
        setErrorFilter( error ) {
            if ( error == '' ) {
                this.errorFilters = [];
            } else if ( this.errorFilters.includes( error ) ) {
                this.errorFilters = this.errorFilters.filter( filter => filter !== error );
            } else {
                this.errorFilters.push( error );
            }
            this.skip = 0;
            this.updateReport();
        },
        async removeRule( ruleId ) {
            var r = confirm( 'Are you sure you want to remove rule?' );

            if ( !r ) {
                return;
            }

            var url = '/rule/' + ruleId;

            const response = await xmlimportsapi.delete( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to remove rule'
                } );
                return;
            }

            notify( {
                type: 'info',
                title: 'Rule was removed'
            } );

            this.matchingRules = this.matchingRules.filter( rule => rule.id !== ruleId );
            this.populateMatchingRules( this.report );
        },
        async startImport(  ) {
            this.processing = true;

            let url = 'run/' + this.reportEntry.agentCode;

            const response = await xmlimportsapi.post( url );

            if ( response.status !== 200 && response.status !== 202 ) {
                this.processing = false;
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to start import'
                } );
                return;
            }

            // check every 5 seconds if import is done
            let interval = setInterval( async () => {
                const response = await xmlimportsapi.get( `/history/${this.reportEntry.agentCode}?take=1` );

                if ( response.status !== 200 ) {
                    clearInterval( interval );
                    this.processing = false;
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to start import'
                    } );
                    return;
                }

                const lastRuns = await response.json();

                if ( lastRuns.length > 0 && lastRuns[ 0 ].end && lastRuns[ 0 ].id > this.reportEntry.id ) {
                    clearInterval( interval );
                    this.processing = false;
                    // reload page
                    window.location.reload();
                }
            }, 3000 );
        }
    }
};

</script>



// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/report.vue